export class User {
  public firstName: string;
  public lastName: string;
  public name: string;
  public userName: string;
  public email: string;
  public isAdmin: boolean;
  public lastSeen: string;
}
